import { LUDUM_MESSAGE_TYPE } from '@/constants';

const { SUCCESS, INFO, WARNING, ERROR } = LUDUM_MESSAGE_TYPE;

/**
 * Create new error object from regular notification.
 *
 * @param notification notification object
 * @param type notification type
 * @returns {Object}  notification error object
 */
export function setNotificationType(notification, type) {
    return Object.assign({}, notification, {
        timestamp: Date.now(),
        type
    });
}
export const globalNotifications = {
    state: {
        notifications: []
    },
    getters: {
        notifications(state) {
            return state.notifications;
        }
    },
    mutations: {
        addNotification(state, err) {
            state.notifications.push(err);
        },
        removeNotification(state, notification) {
            state.notifications = state.notifications.filter(note => notification.timestamp !== note.timestamp);
        },
        removeAllNotifications(state) {
            state.notifications = [];
        }
    },
    actions: {
        notifyError({ commit, dispatch }, notification) {
            dispatch('pushNotification', setNotificationType(notification, ERROR));
        },
        notifySuccess({ commit, dispatch }, notification) {
            dispatch('pushNotification', setNotificationType(notification, SUCCESS));
        },
        notifyInfo({ commit, dispatch }, notification) {
            dispatch('pushNotification', setNotificationType(notification, INFO));
        },
        notifyWarning({ commit, dispatch }, notification) {
            dispatch('pushNotification', setNotificationType(notification, WARNING));
        },
        pushNotification({ commit, dispatch }, msg) {
            if (msg === null || msg.message === null) {
                return;
            }
            commit('addNotification', msg);
            dispatch('autoRemoveNotification', msg);
        },
        // delete it after 3 seconds if notificiation isn't a persistent one
        autoRemoveNotification({ dispatch }, notification) {
            if (!notification.persist) {
                window.setTimeout(() => dispatch('removeNotification', notification), 3000);
            }
        },
        removeNotification({ commit }, notification) {
            commit('removeNotification', notification);
        },
        removeAllNotifications({ commit }) {
            commit('removeAllNotifications');
        }
    }
};
